import { logger } from "common/utilities/logger";

export const safelyExecute = <T, U>(fn: (...args: T[]) => U, ...args: T[]) => {
  try {
    return fn(...args);
  } catch (error) {
    logger.error("[safelyExecute] Failed to execute function", error);
    return undefined;
  }
};
